import { NgModule } from '@angular/core';

import { SharedModule } from '../../../../../../shared';

import { ClienteAnaliseFinanceiraStatusPipe } from './cliente-analise-financeira-status.pipe';
import { ClienteAnaliseFinanceiraStatusBadgePipe } from './cliente-analise-financeira-status-badge.pipe';


@NgModule({
    imports: [
        SharedModule
    ],
    declarations: [
        ClienteAnaliseFinanceiraStatusPipe,
        ClienteAnaliseFinanceiraStatusBadgePipe
    ],
    exports: [
        ClienteAnaliseFinanceiraStatusPipe,
        ClienteAnaliseFinanceiraStatusBadgePipe
    ],
    providers: [
        ClienteAnaliseFinanceiraStatusPipe,
        ClienteAnaliseFinanceiraStatusBadgePipe
    ]
})
export class ClienteAnaliseFinanceiraStatusPipeModule { }
